var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page-layout',{scopedSlots:_vm._u([{key:"pageBody",fn:function(){return [_c('b-row',[_c('b-col',{staticClass:"mb-2"},[_c('b-button',{attrs:{"variant":"primary"}},[_vm._v("Invita un altro membro")])],1)],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }